import React from "react";
import { injectIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import flechaAvanzar from "../../assets/right-arrow.svg";
import ScenarioBar from "../../components/ScenarioBar";
import { ROUTES } from "../../utils/constants";
import { getScenarioNumByPath } from "../../utils/helpers";
import { IconNotebook } from "@tabler/icons-react";
import oncommit from "../../assets/onconext.png";
import avatarVideo from "../../assets/bg/silent-video.webm";
import avatarVideoMp4 from "../../assets/bg/silent-video.mp4";
import { useDispatch, useSelector } from "react-redux";
import { getGameById } from "../../api/game";
import { updateStats, updateTimer, getTimer, setLastTickNow } from "../../utils/helpers";
import { modalWait } from "../../utils/logger";
import robotAvatar from "../../assets/bg/robot-avatar.png";

import { useVideoWithSound } from "../../hooks/useVideoWithSound";

function Scenario1Estudios({ intl }) {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();
	const game = useSelector((state) => state.game);
	const group = useSelector((state) => state.group);
	const [loading, setLoading] = React.useState(false);

	const { videoRef, canPlayWithSound } = useVideoWithSound({ 
		autoPlay: true, 
		volume: 0.8
	});

	const activeScenario = getScenarioNumByPath(location.pathname);

	const handleStartGameHere = async (e) => {
		e.preventDefault();
		if (loading) return; // evita doble click real mientras haces la request
		setLoading(true);

		try {
			const res = await getGameById(game?._id);
			if (res.status !== 200) {
			return; // caerá al finally y quitará loading
			}

			const gameData = res.data;

			// STOPER: si el juego no está activo y no es demo => mostrar modal
			if (!gameData.active && !gameData.demo) {
			// IMPORTANTE: quita el loading ANTES del modal para no “clavar” el botón
			setLoading(false);

			// Muestra el modal (y no dependas de que resuelva para liberar el botón)
			try {
				await modalWait({
				html: `<div class="d-flex flex-column">
						<div>El juego aún no ha empezado.</div>
						<div class="mt-2">Espera a que el moderador dé la orden</div>
						</div>`
				});
			} catch (_) {
				// Si tu wrapper puede lanzar, ignoramos: ya liberamos el botón arriba
			}

			// Fallback por si el modal no aparece por cualquier motivo
			setTimeout(() => {
				const modalOn = document.querySelector('.swal2-container, .swal2-popup');
				if (!modalOn) setLoading(false);
			}, 1500);

			return;
			}

			const alreadyStarted = getTimer() !== null;

			if (alreadyStarted) {
			updateStats({
				...group,
				lastVisited: ROUTES.TRANSITION_SCENARIOS,
			});
			} else {
			const time = group?.time ? parseInt(group.time, 10) : 0;
			updateTimer(time);
			setLastTickNow();

			updateStats({
				...group,
				actualScenario: 1,
				time: 0,
				lastVisited: ROUTES.TRANSITION_SCENARIOS,
			});
			}

			navigate(ROUTES.TRANSITION_SCENARIOS, { state: { activeScenario: 2 } });
		} catch (err) {
			// opcional: loggear
			console.error('Error al iniciar juego aquí:', err);
		} finally {
			// si navegaste, este set no molesta; si no navegaste, libera el botón sí o sí
			setLoading(false);
		}
	};

	return (
		<div className="h-100">
			<div className="container-fluid position-relative h-100">
				<div className="row h-100 d-flex align-items-center">
					<div className="col-md-3 d-flex flex-column justify-content-between h-100 px-4 pb-4">
						<img
							className="mt-5"
							src={oncommit}
							alt="decorativo"
							style={{
								maxWidth: "100%",
							}}
						/>
					</div>
					<div className="col-md-9 d-flex flex-column justify-content-center h-100 pb-3 bg-blur" style={{paddingTop: "10px"}}>
						<div className="container-fluid position-relative h-100 px-5">
							<div className="row d-flex align-items-center">
								<div className="col-md-12">
									<div className="text-center mt-4">
										<img src={robotAvatar} alt="Director" />
									</div>
									<div className="recuadro-white mb-3 w-100 mt-0" style={{marginTop: "10px"}}>
										<p className="txtTexto2 black">
											<strong className="txt-red">Protocolo activado.</strong> Sus decisiones serán evaluadas. Tiempo disponible: limitado.
										</p>
									</div>
								</div>
								<div className="col-md-12 d-flex flex-column justify-content-end align-items-end h-100">
									<div className="d-flex justify-content-end align-items-center mb-4">
										<div className="txtBotones txt-white me-3">
											Siguiente
										</div>
										<button
											onClick={handleStartGameHere}
											className="btn-main btn-progress"
											data-loading={loading ? "true" : "false"}
											aria-busy={loading}
											style={{ width: 60, height: 60, borderRadius: "50%" }}
										>
											<img src={flechaAvanzar} alt="Siguiente" style={{ maxWidth: "40px" }} />
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Scenario1Estudios);
